var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { Chip, Menu, useToast } from '@pocketlaw/tetris';
import { FileSystemProjectContractTerm } from 'shared/domains/apollo/generated/types';
import { useUpdateProjectContractTerm } from './useUpdateProjectContractTerm';
import { getProjectContractTermAppearance, getProjectContractTermIcon, getProjectContractTermLabels } from './utils';
export function ProjectContractTermChip(props) {
    const { contractTerm, projectId, showLabel = false, size = 'small' } = props;
    const { addToast } = useToast();
    const [updateContractTerm] = useUpdateProjectContractTerm();
    const labels = getProjectContractTermLabels();
    const icon = getProjectContractTermIcon(contractTerm);
    const orderedContractTerms = [
        FileSystemProjectContractTerm.NotStarted,
        FileSystemProjectContractTerm.Ongoing,
        FileSystemProjectContractTerm.Terminated,
    ];
    const chipProps = {
        size,
        icon,
        label: showLabel ? t({ message: 'Contract term', comment: 'Project contract term chip - Label' }) : undefined,
        secondary: labels[contractTerm],
        appearance: getProjectContractTermAppearance(contractTerm),
    };
    const handleUpdateContractTerm = (projectContractTerm) => __awaiter(this, void 0, void 0, function* () {
        if (!projectId) {
            return;
        }
        try {
            yield updateContractTerm(projectId, projectContractTerm);
        }
        catch (_a) {
            addToast({
                appearance: 'danger',
                title: t({
                    message: 'Failed to update project contract term',
                    comment: 'Project contract term chip - Error toast title when updating project contract term',
                }),
                message: t({
                    message: 'Something went wrong when updating the project contract term, please try again',
                    comment: 'Project contract term chip - Error toast message when updating project contract term',
                }),
            });
        }
    });
    if (projectId) {
        return (<Menu.Root target={<Chip {...chipProps}/>}>
        {orderedContractTerms.map((ct) => (<Menu.Item key={ct} onClick={() => handleUpdateContractTerm(ct)}>
            {getProjectContractTermIcon(ct)}
            {labels[ct]}
          </Menu.Item>))}
      </Menu.Root>);
    }
    return <Chip {...chipProps}/>;
}
